/* State selector: tabs on the left swap the panel on the right.
   Arrow keys move between tabs; the theme editor opens the state whose block is selected. */
(function () {
  function init(root) {
    if (root.dataset.statesReady) return;
    root.dataset.statesReady = 'true';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });

    root.addEventListener('shopify:block:select', function (e) {
      var tab = e.target.closest && e.target.closest('[role="tab"]');
      if (tab) select(tab, false);
    });
  }

  function initAll() { document.querySelectorAll('[data-states]').forEach(init); }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
